import { ArrowUpRight } from 'lucide-react'
import { safeExternalUrl } from '../lib/card'
import type { DigitalCard } from '../types/card'

const fields: Array<[keyof DigitalCard, string]> = [
  ['linkedin_url', 'LinkedIn'], ['instagram_url', 'Instagram'], ['twitter_url', 'X / Twitter'],
  ['facebook_url', 'Facebook'], ['github_url', 'GitHub'], ['youtube_url', 'YouTube'],
  ['tiktok_url', 'TikTok'], ['telegram_url', 'Telegram'], ['snapchat_url', 'Snapchat'],
  ['pinterest_url', 'Pinterest'], ['behance_url', 'Behance'], ['dribbble_url', 'Dribbble'],
  ['medium_url', 'Medium'], ['discord_url', 'Discord'], ['reddit_url', 'Reddit'],
  ['spotify_url', 'Spotify'], ['soundcloud_url', 'SoundCloud'], ['twitch_url', 'Twitch'], ['vimeo_url', 'Vimeo'],
]

export function SocialLinks({ card }: { card: DigitalCard }) {
  const links = fields.flatMap(([field, label]) => {
    const value = card[field]
    const url = typeof value === 'string' ? safeExternalUrl(value) : null
    return url ? [{ label, url }] : []
  })

  if (card.whatsapp_number) {
    links.unshift({ label: 'WhatsApp', url: `https://wa.me/${card.whatsapp_number.replace(/\D/g, '')}` })
  }
  if (!links.length) return null

  return (
    <section className="social-section card-detail-panel">
      <div className="section-kicker">Find me online</div>
      <div className="social-grid">
        {links.map(({ label, url }) => (
          <a href={url} target="_blank" rel="noreferrer" key={label}>
            <span className="social-monogram">{label.slice(0, 2).toUpperCase()}</span>
            <span>{label}</span><ArrowUpRight size={16} />
          </a>
        ))}
      </div>
    </section>
  )
}
